import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../PageHeader'
import { connect } from 'react-redux'
import GridContent from './GridContent'
import styles from './index.less'
import MenuContext from '../../layouts/MenuContext'
import { goBack } from 'connected-react-router'


const PageHeaderWrapper = ({ children, contentWidth, wrapperClassName,dispatch, top, ...restProps }) => (
  <div className={wrapperClassName}>
    {top}
    <MenuContext.Consumer>
      {value => (
        <PageHeader
        goBack={() => {
          dispatch(goBack())
        }}
          wide={contentWidth === 'Fixed'}
          home={'Home'}
          {...value}
          key="pageheader"
          {...restProps}
          linkElement={Link}
          itemRender={item => {
            return item.title
          }}
        />
      )}
    </MenuContext.Consumer>
    {children ? (
      <div className={styles.content}>
        <GridContent>{children}</GridContent>
      </div>
    ) : null}
  </div>
)

export default connect(({ theme }) => ({
  contentWidth: theme.contentWidth
}))(PageHeaderWrapper)
